import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, Button, FooterActionBar } from '@saviynt/design-system';

import { useLocalization } from '../../../../hooks';
import { useTypedSelector } from '../../../../hooks/use-typedselector';
import Logger from '../../../../services/loggerService';
import { handleUploadResponse } from '../../../../utils';
import { type UploadResult } from '../../data-layer/types';
import { useUploadDiscoveryFileMutation } from '../../data-store/DiscoveryFileUploadApi';

import './FileUploadModalFooter.css';

/**
 * File upload Footer content
 */
function FileUploadModalFooter({
  fileUploadSourceAppId,
}: {
  fileUploadSourceAppId: number;
}) {
  const [uploadDiscoveryFile, { isLoading }] = useUploadDiscoveryFileMutation();
  const dispatch = useDispatch();
  const formatMessage = useLocalization();

  const { isFileValid, uploadedFile } = useTypedSelector(
    (state) => state.discoveryFileUpload
  );

  const handleContinue = async () => {
    if (!uploadedFile) {
      Logger.error('Missing file or upload ID');

      return;
    }

    const result = await uploadDiscoveryFile({
      file: uploadedFile,
      fileUploadId: fileUploadSourceAppId,
    });

    handleUploadResponse(result as UploadResult, dispatch);
  };

  return (
    <FooterActionBar className='FileSourceModalFooter' size='large'>
      <Box className='FileSourceModalFooter-FooterActionBar'>
        <Box className='FileSourceModalFooter-FooterActionBar-Buttons'>
          <Button
            kind={isFileValid ? 'filled' : 'disabled'}
            size='medium'
            onClick={handleContinue}
            isDisabled={!isFileValid || isLoading}
            aria-busy={isLoading}
            dataTestId='aob-fileupload-continue'>
            {isLoading
              ? formatMessage(
                  'INTEGRATIONS.FILEUPLOAD.UPLOADING',
                  'Uploading...'
                )
              : formatMessage('INTEGRATIONS.FILEUPLOAD.CONTINUE', 'Continue')}
          </Button>
        </Box>
      </Box>
    </FooterActionBar>
  );
}

export default FileUploadModalFooter;
